import { trpc, TRPCReactQueryOptions, TRPCRouterInputs } from '@sternum/web/services/trpc';

export function useClient(
  request: TRPCRouterInputs['systemClient']['getClient'],
  options?: TRPCReactQueryOptions['systemClient']['getClient'],
) {
  const { data, ...rest } = trpc.systemClient.getClient.useQuery(request, {
    ...options,
  });

  return {
    client: data,
    ...rest,
  };
}
